import dayjs from 'dayjs';

import {inject, Injector, Pipe, PipeTransform} from '@angular/core';

import {DateTimeService} from '../../services/date-time.service';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

@Pipe({
	name: 'formatDateTime',
	standalone: true,
})
export class DateTimePipe implements PipeTransform {
	private readonly dateTimeService: DateTimeService = inject(DateTimeService);

	transform(date: dayjs.ConfigType, timeFormat?: '' | TimeFormat): string {
		return this.dateTimeService.formatDate(date, timeFormat);
	}
}
